import React from 'react';

const Background = () => {
  return (
    <div className="background">
      <div className="background-pattern"></div>
    </div>
  );
};

export default Background;



